<template>
  <div class="adminAddBox">
    <el-steps :active="active-0" finish-status="success">
      <el-step title="填写配置基本信息"></el-step>
      <el-step title="上传职工表"></el-step>
      <el-step title="法定节假日及考勤上传截止时间"></el-step>
    </el-steps>
    <el-tabs v-model="active" style="height:500px">
      <el-tab-pane name="0" style="height: 500px;">
        <Form ref="addForm" :label-width="130" :model="formCustom" :rules="addRules" inline>
          <Form-item label="所属集团公司：" prop="companyId">
            <el-select
              v-model="formCustom.companyId"
              :disabled="!isadd"
              :loading="loading"
              :remote-method="remoteMethod"
              filterable
              placeholder="请输入关键词"
              remote
              reserve-keyword
              @change="changeCompanyId">
              <el-option
                v-for="item in options"
                :key="item.organizationId"
                :label="item.organizationName"
                :value="item.organizationId">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="考勤年月：" prop="attendanceDate">
            <DatePicker
              v-model="formCustom.attendanceDate"
              :disabled="!isadd"
              type="month"
            />
          </Form-item>
        </Form>
        <div style="cursor: pointer;width: 100px;" @click="download()">
          <span style="color: #1890FF;">下载模板</span><i class="el-icon-download"></i>
        </div>
        <div>温馨提示：下载模板后，按照模板填写职工信息后下一步上传。</div>
      </el-tab-pane>
      <el-tab-pane name="1" style="text-align:center">
        <template>
          <el-upload
            :action="BaseUrl+'org/auth/companyEmployee/upload'"
            :data="{companyAttendanceConfigId:companyAttendanceConfigId}"
            :headers="headers"
            :on-error="handleError"
            :on-success="handleSuccess"
            class="upload-demo"
            drag
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </template>
        <div v-if="showTable">
          <Table
            :columns="columns"
            :data="tableData"
            :loading="loading"
            aria-describedby=""
            aria-hidden="true" border
          >
          </Table>
          <Page
            ref="pages"
            :current="page"
            :total="total"
            class="page_position"
            show-elevator
            show-sizer
            show-total
            style="margin-bottom: 80px;"
            @on-change="setCurrent"
            @on-page-size-change="setPage"
          ></Page>
        </div>
      </el-tab-pane>
      <el-tab-pane name="2">
        <Form ref="festivalForm" :label-width="130" :model="formCustom" :rules="addRules" inline style="width: 300px;">
          <Form-item label="法定节日：">
            <el-date-picker
              v-model="formCustom.holidayConfig"
              :default-value="nowtime"
              :picker-options="pickerOptions"
              placeholder="选择一个或多个日期"
              type="dates"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </Form-item>
          <Form-item label="假日：">
            <el-date-picker
              v-model="formCustom.weekendConfig"
              :default-value="nowtime"
              :picker-options="pickerOptions"
              placeholder="选择一个或多个日期"
              type="dates"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </Form-item>
          <Form-item label="考勤上传截止时间：" prop="attendanceDate">
            <el-date-picker
              v-model="formCustom.cutoffTime"
              :default-value="nowtime"
              placeholder="选择日期"
              type="datetime">
            </el-date-picker>
          </Form-item>
        </Form>
      </el-tab-pane>
      <el-tab-pane name="3">
        <div style="width: 100%;display: flex;flex-direction: column;align-items: center;">
          <div class="success">
            <p><i class="el-icon-success" style="color: #52c41a;margin-top: 100px;font-size: 100px;"></i></p>
            <p style="margin-top: 20px;">提交成功</p>
            <p style="margin-top: 20px;">5秒后自动跳转至考勤配置列表</p>
            <Button style="margin-top: 20px;" type="primary" @click="handleBack">返回考勤配置列表</Button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="footerButton">
      <Button type="default" @click="handleBack('add')">返回</Button>
      <Button v-if="active != '2'" type="primary" @click="next">下一步</Button>
      <Button v-if="active == '2'" type="primary" @click="next">完成</Button>
    </div>
  </div>
</template>

<script>
import {
  companyAdd,
  companyAttendanceConfigAdd,
  companyAttendanceConfigDetail,
  companyAttendanceConfigPut,
  companyEmployeePage,
  downloadErr
} from '@/api/attendance'
import {companyPage} from '@/api/organization'

import axios from 'axios'

let attendanceDate = '';
export default {
  name: 'adminAdd',
  data() {
    return {
      value: '',
      addLoading: false,
      showTable: false,
      BaseUrl: process.env.VUE_APP_BASE_URL,
      roleDisabled: true, // 关联角色disabled
      roleList: [], // 关联角色下拉框
      roleId: '', // 下拉框关联角色ID
      formCustom: {
        companyId: '',
        attendanceDate: '',
        holidayConfig: '',
        weekendConfig: '',
        cutoffTime: ''
      },
      addRules: {
        companyId: [{required: true, message: '所属集团公司不能为空'}],
        attendanceDate: [{required: true, message: '考勤年月不能为空'}]
      },
      active: '0',
      columns: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属企业", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "姓名", key: "employeeRealName", align: "center"},
        {title: "身份证号", key: "employeeIdNumber", align: "center"},
        {title: "职位", key: "employeePositionName", align: "center"},
      ],
      tableData: [],
      companyAttendanceConfigId: '',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('getToken')
      },
      loading: false,
      nowtime: '',
      total: 0,
      page: 1,
      size: 10,
      pageSize: 10,
      timers: null,
      countDown: null,
      pickerOptions: {
        disabledDate(time) {
          let month = attendanceDate.getMonth()
          let year = attendanceDate.getFullYear()
          const startTime = new Date(year, month, 1).getTime();
          const endTime = new Date(year, month + 1, 1).getTime() - 1
          return time.getTime() > endTime || time.getTime() < startTime
        },
      },
      options: [],
      companyId: '',
      detail: {},
      isadd: true
    }
  },
  mounted() {
    if (this.$route.query.companyAttendanceConfigId) {
      this.companyAttendanceConfigId = this.$route.query.companyAttendanceConfigId
      this.companyId = this.$route.query.companyId
      this.formCustom.attendanceDate = this.$route.query.attendanceDate
      this.formCustom.companyId = this.$route.query.companyName
      this.isadd = false
    } else {
      this.isadd = true
    }
    companyPage({
      current: 1,
      size: 99
    }).then((res) => {
      this.options = res.data.data.records
    })
  },
  methods: {
    // 返回
    next() {
      let a = Number(this.active);
      if (a == 0) {
        //添加考勤
        console.log(this.formCustom)
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            if (this.companyAttendanceConfigId) {
              // companyAttendanceConfigPut({
              //   attendanceDate: this.formCustom.attendanceDate && this.$moment(this.formCustom.attendanceDate).format('YYYY-MM'),
              //   companyId: this.companyId,
              //   companyAttendanceConfigId: this.companyAttendanceConfigId
              // }).then((res) => {
              //   a++
              //   this.active = a.toString()
              //   this.success()
              // })
              a++
              this.active = a.toString()
              this.success()
            } else {
              companyAttendanceConfigAdd({
                attendanceDate: this.formCustom.attendanceDate && this.$moment(this.formCustom.attendanceDate).format('YYYY-MM'),
                companyId: this.companyId
              }).then((res) => {
                if (res.data.success === false) {
                  this.$Message.error(res.data.msg)
                } else {
                  this.companyAttendanceConfigId = res.data.data
                  a++
                  this.active = a.toString()
                }
              })
            }
            attendanceDate = this.formCustom.attendanceDate
            let month = attendanceDate.getMonth()
            let year = attendanceDate.getFullYear()
            this.nowtime = new Date(year, month, 1)
          }
        })
      } else if (a == 1) {
        if (this.showTable) {
          companyAttendanceConfigDetail(this.companyAttendanceConfigId).then((res) => {
            this.formCustom.cutoffTime = res.data.data.cutoffTime
            this.formCustom.holidayConfig = (res.data.data.holidayConfig?.split(',')) || []
            this.formCustom.weekendConfig = (res.data.data.weekendConfig?.split(',')) || []
            a++
            this.active = a.toString()
          })
        } else {
          this.$Message.error('请先上传职工信息')
        }
      } else if (a == 2) {
        if (this.formCustom.cutoffTime) {
          let holidayConfig = ""
          if (this.formCustom.holidayConfig) {
            holidayConfig = this.formCustom.holidayConfig.join(',')
          }
          let weekendConfig = ""
          if (this.formCustom.weekendConfig) {
            weekendConfig = this.formCustom.weekendConfig.join(',')
          }
          companyAttendanceConfigPut({
            attendanceDate: this.formCustom.attendanceDate && this.$moment(this.formCustom.attendanceDate).format('YYYY-MM'),
            companyId: this.companyId,
            companyAttendanceConfigId: this.companyAttendanceConfigId,
            cutoffTime: this.$moment(this.formCustom.cutoffTime).format('YYYY-MM-DD HH:mm:ss'),
            holidayConfig: holidayConfig,
            weekendConfig: weekendConfig,
          }).then((res) => {
            this.$router.push({path: '/companyAttendance/attendanceConfiguration'})
          })
        } else {
          this.$Message.error('请先选择考勤上传截止时间')
        }
      }
    },
    count() {
      const count = 5
      this.countDown = count
      this.timers = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--
        } else {
          clearInterval(this.timers)
          this.$router.push({path: '/companyAttendance/attendanceConfiguration'})
        }
      }, 1000)
    },
    // 导入成功
    success() {
      // 上传后获取详情
      companyEmployeePage({
        companyAttendanceConfigId: this.companyAttendanceConfigId,
        current: 1,
        size: 10
      }).then((res1) => {
        this.changeData(res1)
      })
    },
    handleSuccess() {
      this.$Message.success('导入成功')
      // 上传后获取详情
      companyEmployeePage({
        companyAttendanceConfigId: this.companyAttendanceConfigId,
        current: 1,
        size: 10
      }).then((res1) => {
        this.changeData(res1)
      })
    },
    // 导入失败
    handleError(err, file) {
      if (err) {
        const erro = JSON.parse(err.message);
        if (erro.code === '100050') {
          this.$alert('导入失败，请查看错误提示模版', '提示', {
            confirmButtonText: '确定',
          });
          downloadErr({delete: true, fileName: erro.data}).then(res => {
            if (res) {
              const link = document.createElement('a')
              let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
              link.style.display = 'none'
              link.href = URL.createObjectURL(blob)
              link.download = '企业职工明细错误信息统计.xlsx' // 下载的文件名
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            }
          })
        } else {
          this.$alert(erro.msg, '提示', {
            confirmButtonText: '确定',
          });
        }
      }
    },
    changeData(res) {
      this.total = res.data.data.total;
      this.size = res.data.data.size;
      this.tableData = res.data.data.records;
      this.loading = false;
      if (res.data.data.total) {
        this.showTable = true
      }
    },
    setCurrent(val) {
      this.loading = true;
      this.page = val;
      companyEmployeePage({
        current: val,
        size: this.pageSize,
        companyAttendanceConfigId: this.companyAttendanceConfigId
      }).then((res) => {
        this.changeData(res);
      });
    },
    // 改变每页条数
    setPage(val) {
      this.loading = true;
      this.pageSize = val;
      companyEmployeePage({
        current: 1,
        size: this.pageSize,
        companyAttendanceConfigId: this.companyAttendanceConfigId
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      })
    },
    handleBack() {
      this.$router.push(
        {
          path: '/companyAttendance/attendanceConfiguration'
        }
      )
    },
    // 提交
    handleCommit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.addLoading = true
          companyAdd({...this.formCustom, organizationType: 1}).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.addLoading = false
            } else {
              this.$Message.success(response.data.msg)
              this.addLoading = false
              this.$router.push({path: '/companyAttendance/attendanceConfiguration'})
            }
          }).catch(() => {
            this.addLoading = false
          })
        }
      })
    },
    download() {
      axios({
        baseURL: process.env.VUE_APP_BASE_URL,
        url: `org/auth/companyEmployee/template`,
        responseType: 'blob',
        method: 'get',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('getToken')
        },
      }).then((res) => {
        const link = document.createElement('a')
        const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
        link.style.display = 'none'
        link.download = '企业职工模板.xlsx'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      })
    },
    remoteMethod(q) {
      companyPage({
        current: 1,
        size: 999,
        organizationName: q,
      }).then((res) => {
        this.options = res.data.data.records
      });
    },
    changeCompanyId(id) {
      this.companyId = id
    }
  }
}
</script>
<style>
.success {
  width: 702px;
  height: 502px;
  line-height: 17px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  text-align: center;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(235, 235, 235, 1);
}

</style>
<style>
.el-picker-panel__footer .el-picker-panel__link-btn.el-button--text {
  display: none;
}
</style>
